const ICONS = {
  view: 'assets/glyphicons/glyphicons-basic-846-square-info.svg',
  edit: "assets/glyphicons/glyphicons-basic-151-square-edit.svg",
  add: 'assets/glyphicons/glyphicons-basic-371-plus.svg',
  hide: 'assets/glyphicons/glyphicons-basic-52-eye.svg',
  unhide: 'assets/glyphicons/glyphicons-basic-53-eye-off.svg',
  back: 'assets/glyphicons/glyphicons-basic-213-arrow-left.svg',
  copy: 'assets/glyphicons/glyphicons-basic-611-copy-duplicate.svg',
  delete: 'assets/glyphicons/glyphicons-basic-17-bin.svg',
  video: "assets/glyphicons/glyphicons-basic-181-video.svg",
  forward: 'assets/glyphicons/glyphicons-basic-177-forward.svg',
  help: 'assets/glyphicons/glyphicons-basic-635-circle-question.svg',
  void: 'assets/glyphicons/glyphicons-basic-305-no-symbol.svg',
  print: 'assets/glyphicons/glyphicons-basic-16-print.svg',
  favorite: 'assets/glyphicons/glyphicons-basic-49-star.svg',
  unfavorite: 'assets/glyphicons/glyphicons-basic-50-star-empty.svg',
  yes: 'assets/glyphicons/glyphicons-basic-739-check.svg',
  no: 'assets/glyphicons/glyphicons-basic-193-circle-empty-remove.svg',
  import: 'assets/glyphicons/glyphicons-basic-399-import.svg',
  email: 'assets/glyphicons/glyphicons-basic-11-envelope.svg',
  clockIn: 'assets/glyphicons/glyphicons-basic-55-clock.svg',
  clockOut: 'assets/glyphicons/glyphicons-basic-58-history.svg',
  agencyBuzz: 'assets/glyphicons/agencyBuzz.jpeg'
};

export default ICONS;
